import React from 'react';
import Logo from '../Logo/Logo';
import { MainBarWrapper, FlexRight, StyledButton } from './MainBar.Styles';
import Avatar from '../Avatar/Avatar';
import UserName from '../UserName/UserName';
import { useAuth0 } from '../../react-auth0-spa';
import { useSelector } from 'react-redux';

const MainBar = () => {
  const { logout, user } = useAuth0();
  const authUserData = useSelector((state) => state.authenticatedUserData);
  return (
    <MainBarWrapper>
      <Logo
        logo={
          authUserData &&
          authUserData !== 'no user' &&
          authUserData.company.name
        }
      />
      <FlexRight>
        <Avatar shape="square" size="medium" icon="user" />
      </FlexRight>
      <UserName userName={user.name} />
      <StyledButton icon="logout" size="default" onClick={() => logout()}>
        Wyloguj
      </StyledButton>
    </MainBarWrapper>
  );
};

export default MainBar;
